import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import PostComponent from 'flarum/forum/components/Post';
app.initializers.add('linku-cleantalk', () => {
  // The flags extension only renders a label for flags of type "user"
  // (Post.prototype.flagReason); give the cleantalk type one too, with
  // CleanTalk's verdict as the detail line.
  override(PostComponent.prototype, 'flagReason', function (original, flag) {
    if (flag.type() === 'cleantalk') {
      const detail = flag.reasonDetail();
      return [app.translator.trans('linku-cleantalk.forum.post.cleantalk_flagged_text'), !!detail && m("span", {
        className: "Post-flagged-detail"
      }, detail)];
    }
    return original(flag);
  });
});